
        import 'Welcome.a18ce60.css-module'
        export default {"WelcomeContainer":"WelcomeContainer_Welcome_a18ce60","Welcome":"Welcome_Welcome_a18ce60","textContent":"textContent_Welcome_a18ce60","email":"email_Welcome_a18ce60","navigation":"navigation_Welcome_a18ce60"}
    